module.exports = "img {\n  height: 100%;\n  max-width: 100%;\n  display: block;\n  margin: auto; }\n"